
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5bfb6060&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./goodscomment.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./goodscomment.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5bfb6060!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./goodscomment.vue"),
  /* scopeId */
  "data-v-5bfb6060",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/staging/goodscomment.vue
// module id = 1572
// module chunks = 3